module.exports = __webpack_public_path__ + "static/1-24d39f43e2a0cbc85ce9194c69a161bf.jpg";